import React, { ReactNode, useCallback, useState } from 'react'
import { AllocationContext, AllocationPhase } from './AllocationContext'

interface AllocationProviderProps {
  children: ReactNode
}

const AllocationProvider: React.FC<AllocationProviderProps> = ({ children }) => {
  const [phase, setPhase] = useState<AllocationPhase>('questionnaire')

  const reset = useCallback(() => {
    setPhase('questionnaire')
  }, [])

  return (
    <AllocationContext.Provider
      value={{
        phase,
        setPhase,
        reset
      }}
    >
      {children}
    </AllocationContext.Provider>
  )
}

export default AllocationProvider
